import React, { Component } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import NominaCatalogoManager from '../../../../catalogs/managers/NominaCatalogoManager';

class NominaIncapacidadesForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      TipoIncapacidad: ['required', 'string', 'in:01,02,03,04'],
      DiasIncapacidad: ['required', 'integer', 'min:1'],
      ImporteMonetario: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
    };
  }

  componentDidMount() {
    this.fillCatalogs();
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      const validator = this.validate(data);

      this.setState({
        data: { ...data },
        validator,
        isValid: validator.passes(),
      });
    }
  }

  fillCatalogs = async () => {
    if (!this.state.catalogos) {
      const values = await NominaCatalogoManager.get('c_nom_tipo_incapacidad');

      if (!!values) {
        let catalogos = {};

        const sorted = _.sortBy(
          values.map((item) => {
            return {
              label: item.descripcion,
              value: item.tipo,
            };
          }),
          'label'
        );

        catalogos.tipoIncapacidad = sorted;

        this.setState({
          catalogos,
        });
      }
    }
  };

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  };

  handleOnChange = (values) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      validator,
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      data: {},
      isValid: false,
    });
  };

  render() {
    const rules = this.rules;
    const { isValid, data = {}, catalogos = {} } = this.state;

    return (
      <>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Tipo Incapacidad"
              name="TipoIncapacidad"
              placeholder=""
              help=""
              options={catalogos.tipoIncapacidad}
              rules={rules.TipoIncapacidad}
              value={data.TipoIncapacidad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Dias Incapacidad"
              name="DiasIncapacidad"
              placeholder=""
              help=""
              min="1"
              rules={rules.DiasIncapacidad}
              value={data.DiasIncapacidad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Importe Monetario"
              name="ImporteMonetario"
              placeholder=""
              help=""
              min="0"
              rules={rules.ImporteMonetario}
              value={data.ImporteMonetario}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias incapacidades usando el botón "Agregar incapacidad", las incapacidades se mostrarán
              en la tabla de incapacidades.
            </p>
          </Col>
        </Row>

        <Row className="pb-3">
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar incapacidad
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default NominaIncapacidadesForm;
